var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBodyellenskeptical({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 412,
    height: 600,
    preserveAspectRatio: "xMidYMax",
    viewBox: "0 0 412 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "body_ellen_skeptical_svg__c",
    d: "M10.501 131.906c0-35.108-7.673-108.325-7.673-108.325C1.593 11.067 10.784.923 23.36.923h299.715c12.576 0 21.719 10.131 20.464 22.652 0 0-7.604 70.249-7.604 103.87 0 41.137 9.91 123.412 9.91 123.412H.591s9.91-79.3 9.91-118.95z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "body_ellen_skeptical_svg__e",
    d: "M.517 46.885V28.103C.517 12.86 12.881.501 28.14.501c15.256 0 27.623 12.367 27.623 27.61v18.774"
  }), /*#__PURE__*/React.createElement("path", {
    id: "body_ellen_skeptical_svg__g",
    d: "M0 131.894C0 59.051 59.056 0 131.895 0 204.739 0 263.79 59.044 263.79 131.894v63.565c0 72.844-58.883 136.317-131.517 141.771l-.378.028-.378-.028C58.882 331.775 0 268.31 0 195.46v-63.566z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "body_ellen_skeptical_svg__i",
    d: "M145.704 136.444c70.728-.14 141.157-21.602 141.157-21.602S277.058 18.024 144.797 0C12.193 18.024.532 114.842.532 114.842s73.84 21.744 145.172 21.602z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "body_ellen_skeptical_svg__k",
    d: "M1.002 8.48S26.767-9.2 58.477 6.5C37.745 29.42 1.002 8.48 1.002 8.48z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "body_ellen_skeptical_svg__a",
    width: 412,
    height: 602,
    x: 0,
    y: -1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "body_ellen_skeptical_svg__m",
    width: 81.5,
    height: 53.94,
    x: 0.528,
    y: 0.529,
    rx: 17.68
  }), /*#__PURE__*/React.createElement("rect", {
    id: "body_ellen_skeptical_svg__o",
    width: 81.5,
    height: 53.94,
    x: 0.528,
    y: 0.529,
    rx: 17.68
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "body_ellen_skeptical_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#body_ellen_skeptical_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#body_ellen_skeptical_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(33 28)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.657 .775)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C6C6C",
    stroke: "#363A4F",
    strokeWidth: 11,
    d: "M320.819 140.849l-11.705 186H28.974l-11.704-186h303.549z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 170.146,
    cy: 154.051,
    fill: "#6C6C6C",
    stroke: "#363A4F",
    strokeWidth: 11,
    rx: 154.722,
    ry: 158.451
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 372.197)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "body_ellen_skeptical_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#body_ellen_skeptical_svg__c"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F15165",
    stroke: "#363A50",
    strokeWidth: 22.968,
    xlinkHref: "#body_ellen_skeptical_svg__c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBDCCE",
    d: "M10.501 129.873c0-34.704-7.638-106.305-7.638-106.305C1.61 11.061 10.783.923 23.361.923h299.715c12.576 0 21.667 10.134 20.352 22.65 0 0-7.492 65.838-7.492 97.662 0 40.54 9.91 121.622 9.91 121.622H.591s9.91-75.322 9.91-112.984z",
    mask: "url(#body_ellen_skeptical_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M124.63-5.063s50.22 172.379 106.65.37c59.684-88.795 185.16 45.888 185.16 45.888l-90.287 249.998L-33.36 277.43-31.07 3.07l155.7-8.133z",
    mask: "url(#body_ellen_skeptical_svg__d)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    fillOpacity: 0.1,
    points: "303.699 219.112 309.645 106.198 317.573 216.984",
    mask: "url(#body_ellen_skeptical_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8CCB8",
    stroke: "#363A50",
    strokeWidth: 10.89,
    d: "M343.113 100.24l-33.693 1.98s-4.954 120.753 5.946 130.743c10.9 9.99 57.476 17.914 57.476 17.914l17.837-37.638-47.566-113z",
    mask: "url(#body_ellen_skeptical_svg__d)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    fillOpacity: 0.1,
    points: "312.585 110.436 329.104 114.838 341.218 225.975 353.375 216.071 343.464 107.135 318.135 108.235",
    mask: "url(#body_ellen_skeptical_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8CCB8",
    stroke: "#363A50",
    strokeWidth: 10.89,
    d: "M4.071 100.24l33.693 1.98.105 2.766h0l.16 4.604h0l.095 3.017h0l.173 5.96h0l.106 4.073h0l.104 4.4h0l.097 4.69h0l.06 3.268h0l.056 3.37h0l.049 3.459h0l.041 3.538h0l.034 3.605h0l.025 3.662h0l.015 3.708h0l.003 3.741c-.02 32.542-1.4 67.688-7.069 72.882-3.815 3.497-12 6.74-21.03 9.48l-1.555.464c-.52.153-1.043.304-1.568.454l-1.576.444c-.527.146-1.054.29-1.582.433l-1.582.423h0l-1.579.41h0l-1.571.4h0l-1.561.388h0l-1.546.375h0l-1.526.363h0l-1.504.35h0l-2.203.501h0l-2.13.471h0l-1.373.297h0l-2.612.551h0l-2.41.492h0l-2.177.432h0l-1.91.368h0l-2.3.43h0l-2.18.388h0l-17.838-37.638 47.566-113z",
    mask: "url(#body_ellen_skeptical_svg__d)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    fillOpacity: 0.1,
    points: "9.862 103.868 26.381 115.972 24.179 223.808 32.989 224.909 37.394 157.692 34.09 105.975",
    mask: "url(#body_ellen_skeptical_svg__d)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 300.389,
    cy: 216.873,
    fill: "#FBDCCE",
    stroke: "#363A50",
    strokeWidth: 8.91,
    rx: 36.055,
    ry: 36.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 308.31,
    cy: 242.028,
    fill: "#363A50",
    rx: 6.057,
    ry: 6.052
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.501,
    cy: 214.892,
    fill: "#FBDCCE",
    stroke: "#363A50",
    strokeWidth: 8.91,
    rx: 36.055,
    ry: 36.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.029,
    cy: 215.08,
    fill: "#000",
    fillOpacity: 0.1,
    rx: 15.418,
    ry: 15.405
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 306.029,
    cy: 215.08,
    fill: "#000",
    fillOpacity: 0.1,
    rx: 15.418,
    ry: 15.405
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(147.653 317.72)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "body_ellen_skeptical_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#body_ellen_skeptical_svg__e"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F9CCB6",
    stroke: "#363A50",
    strokeWidth: 13.86,
    xlinkHref: "#body_ellen_skeptical_svg__e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8CCB8",
    d: "M9.043 13.708S-2.85 51.346 27.87 71.156c30.72 19.81-5.946 18.819-5.946 18.819l-40.63-33.676-.99-36.648 28.738-5.943z",
    mask: "url(#body_ellen_skeptical_svg__f)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.989 18.024)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "body_ellen_skeptical_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#body_ellen_skeptical_svg__g"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F9CCB6",
    xlinkHref: "#body_ellen_skeptical_svg__g"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBDCCE",
    stroke: "#363A50",
    strokeWidth: 11,
    d: "M131.917 5.5c34.895.006 66.486 14.151 89.354 37.02 22.873 22.871 37.019 54.47 37.019 89.374h0v63.565c0 35.013-14.179 67.758-37.053 92.416-22.784 24.56-54.217 41.119-88.969 43.839-35.077-2.718-66.668-19.236-89.544-43.754C19.71 263.295 5.5 230.515 5.5 195.46h0v-63.566c0-34.524 13.843-65.815 36.28-88.626C64.25 20.423 95.342 6.082 129.78 5.518h0z",
    mask: "url(#body_ellen_skeptical_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#363A50",
    fillOpacity: 0.1,
    d: "M237.402 126.006s53.054 157.453-90.68 212.008c-143.734 54.554 127.922-24.657 127.922-24.657L374.69 73.92l-128.97 42.375-8.32 9.71z",
    mask: "url(#body_ellen_skeptical_svg__h)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "body_ellen_skeptical_svg__j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#body_ellen_skeptical_svg__i"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A4F",
    strokeWidth: 8.8,
    d: "M144.817-4.437l.575.077C282.052 14.264 291.238 114.4 291.238 114.4s.118 1.285.135 3.624c-1.748.57-2.825.903-3.136 1l-.07.02-.024.008-.02.006c-1.4.425-71.758 21.647-142.41 21.787-67.63.134-137.496-19.23-145.637-21.554l-.435-.125a76.597 76.597 0 01-.352-.102s-1.178-.347-3.356-1.031c.077-2.402.23-3.716.23-3.716S1.368 69.648 45.72 34.342C67.571 16.947 98.997 1.785 144.205-4.36c.196-.027.391-.053.612-.077z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C6C6C",
    stroke: "#363A4F",
    strokeWidth: 8.8,
    d: "M144.876-4.45l.67.114C320.18 25.846 291.186 175.657 291.186 175.657l-.018.09-.023.11c-.127.616-.564 2.635-1.424 5.728a189.004 189.004 0 00-4.66-2.71l-.136-.076a35.573 35.573 0 00-.175-.097s-69.362-37.996-139.036-37.858c-70.351.14-143.157 37.905-143.157 37.905s-1.78.923-4.938 2.696c-.846-3.098-1.275-5.119-1.399-5.729-.816-4.027-13.345-69.964 29.419-121.792C47.525 27.398 83.913 4.412 144.164-4.354c.228-.033.456-.066.712-.097z",
    mask: "url(#body_ellen_skeptical_svg__j)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#363A50",
    fillOpacity: 0.2,
    d: "M163.326-9.775S265.287 62.569 265.287 92.967c0 30.398-218.601-46.187-271.234 85.04-52.633 131.226 43.86 46.023 43.86 46.023l320.124-22.149 20.14-141.57-127.14-66-87.71-4.086z",
    mask: "url(#body_ellen_skeptical_svg__j)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 6,
    d: "M272.085 159.856c-6.895-11.942-25.925-13.863-42.504-4.29M80.024 156.884c6.894-11.942 25.924-13.863 42.504-4.29"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 244.272,
    cy: 185.492,
    fill: "#FFF",
    rx: 19.324,
    ry: 19.314
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.61,
    cy: 185.492,
    fill: "#FFF",
    rx: 19.324,
    ry: 19.314
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 4.851,
    d: "M23.478 211.172c5.91-3.551 13.578-1.64 17.128 4.267h0c3.55 5.907 1.636 13.575-4.274 17.126M302.444 203.426c5.203-4.523 13.087-3.974 17.608 1.228h0c4.522 5.201 3.97 13.085-1.234 17.608"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 243.806,
    cy: 185.678,
    fill: "#363A50",
    rx: 10.462,
    ry: 10.453
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.806,
    cy: 185.678,
    fill: "#363A50",
    rx: 10.462,
    ry: 10.453
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#363A50",
    points: "134.713 140.914 143.988 48.587 149.916 140.819"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#363A50",
    points: "224.658 134.248 231.377 69.327 235.671 134.182"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#363A50",
    points: "80.392 134.051 87.111 69.13 91.405 133.985"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144.266 282.493)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "body_ellen_skeptical_svg__l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#body_ellen_skeptical_svg__k"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#E68794",
    xlinkHref: "#body_ellen_skeptical_svg__k"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E68794",
    d: "M1.002 8.48S26.767-9.2 58.477 6.5C37.745 29.42 1.002 8.48 1.002 8.48z",
    mask: "url(#body_ellen_skeptical_svg__l)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    fillOpacity: 0.1,
    points: "1.072 8.106 63.844 7.006 7.679 -8.399",
    mask: "url(#body_ellen_skeptical_svg__l)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 28,
    x: 149,
    y: 360.695,
    fill: "#FBDCCE"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M151.433 353.505s54.01 7.702 54.01 20.907l3.303-27.51-57.313 6.603z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M199.397 255.847s-2.073 23.06 19.87 27.462l-16.6 2.2-4.405-6.601 1.135-23.06z",
    mask: "url(#body_ellen_skeptical_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 5.103,
    d: "M196.48 272.348c0 7.19 5.828 13.02 13.016 13.02h0c7.188 0 13.016-5.83 13.016-13.02",
    mask: "url(#body_ellen_skeptical_svg__b)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#body_ellen_skeptical_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(71 207)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(153 12)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "body_ellen_skeptical_svg__n",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#body_ellen_skeptical_svg__m"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 68.9,
    height: 41.34,
    x: 6.828,
    y: 6.829,
    fill: "#FFF",
    fillOpacity: 0.5,
    stroke: "#363A4F",
    strokeWidth: 12.6,
    mask: "url(#body_ellen_skeptical_svg__n)",
    rx: 17.68
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    fillOpacity: 0.05,
    points: "4.391 .529 80.606 58.372 .528 57.025",
    mask: "url(#body_ellen_skeptical_svg__n)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33 12)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "body_ellen_skeptical_svg__p",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#body_ellen_skeptical_svg__o"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 68.9,
    height: 41.34,
    x: 6.828,
    y: 6.829,
    fill: "#FFF",
    fillOpacity: 0.5,
    stroke: "#363A4F",
    strokeWidth: 12.6,
    mask: "url(#body_ellen_skeptical_svg__p)",
    rx: 17.68
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    fillOpacity: 0.05,
    points: "4.391 .529 80.606 58.372 .528 57.025",
    mask: "url(#body_ellen_skeptical_svg__p)"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 117.645,
    x2: 159.213,
    y1: 36.867,
    y2: 36.867,
    stroke: "#363A4E",
    strokeLinecap: "square",
    strokeWidth: 12.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235.089,
    x2: 271.792,
    y1: 20.014,
    y2: 0.499,
    stroke: "#363A4E",
    strokeLinecap: "square",
    strokeWidth: 12.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.089,
    x2: 36.792,
    y1: 20.014,
    y2: 0.499,
    stroke: "#363A4E",
    strokeLinecap: "square",
    strokeWidth: 12.6,
    transform: "matrix(-1 0 0 1 36.881 0)"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.967,
    cy: 270.803,
    fill: "#363A50",
    mask: "url(#body_ellen_skeptical_svg__b)",
    rx: 6.057,
    ry: 6.052
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyellenskeptical);
export default __webpack_public_path__ + "static/media/body.ellen.skeptical.407006ec.svg";
export { ForwardRef as ReactComponent };